export default [
  {
    key: 'title',
    label: 'field.title',
    type: 'text',
    md: 6,
    lg: 6,
  },
];